export const mockSports = [
  {
    id: 'bif6kkbp0dp4vp059t0g',
    code: 'soccer',
    name: 'Football',
    active: true,
  },
  {
    id: 'bif6kkjp0dp4vp059t10',
    code: 'tennis',
    name: 'Tennis',
    active: true,
  },
  {
    id: 'bif6kkrp0dp4vp059t1g',
    code: 'ice-hockey',
    name: 'Ice Hockey',
    active: true,
  },
  {
    id: 'bif6kkrp0dp4vp059t20',
    code: 'handball',
    name: 'Handball',
    active: true,
  },
  {
    id: 'bif6kkrp0dp4vp059t2g',
    code: 'basketball',
    name: 'Basketball',
    active: true,
  },
  {
    id: 'bif6kl3p0dp4vp059t30',
    code: 'american-football',
    name: 'American Football',
    active: true,
  },
  {
    id: 'bif6klbp0dp4vp059t4g',
    code: 'volleyball',
    name: 'Volleyball',
    active: true,
  },
  {
    id: 'bif6klbp0dp4vp059t50',
    code: 'futsal',
    name: 'Futsal',
    active: false,
  },
  {
    id: 'bif6kljp0dp4vp059t5g',
    code: 'esports',
    name: 'E-Games',
    active: true,
  },
  {
    id: 'boffjln2s2m9mfqtatkg',
    code: 'squash',
    name: 'Squash',
    active: true,
  },
  {
    id: 'bq3gno42eusphmf48vf0',
    code: 'table-tennis',
    name: 'Table Tennis',
    active: true,
  },
  {
    id: 'bqephof96j4dnfcducb0',
    code: 'darts',
    name: 'Darts',
    active: false,
  },
  {
    id: 'bt8lf4s2eusuegneqrbg',
    code: 'baseball',
    name: 'Baseball',
    active: true,
  },
  {
    id: 'btrki7n96j49qd0pcbm0',
    code: 'cycling',
    name: 'Cycling',
    active: false,
  },
  {
    id: 'btrkip796j4a7s6sjfn0',
    code: 'martial-arts',
    name: 'Martial Arts',
    active: true,
  },
  {
    id: 'btrkipf96j4a6dj9vnm0',
    code: 'motor',
    name: 'Motor',
    active: true,
  },
  {
    id: 'btrkipn96j4a6uvf8vdg',
    code: 'paddle',
    name: 'Paddle',
    active: false,
  },
  {
    id: 'bucom1n96j4dplt88q5g',
    code: 'other',
    name: 'Other',
    active: true,
  },
  {
    id: 'ccg351c4s2672oaqf8d0',
    code: 'multisport',
    name: 'Multisport',
    active: false,
  },
];
export const mockFeaturedSports = [
  {
    id: 'bif6kkbp0dp4vp059t0g',
    code: 'soccer',
    name: 'Football',
    active: true,
  },
  {
    id: 'bif6kkjp0dp4vp059t10',
    code: 'tennis',
    name: 'Tennis',
    active: true,
  },
  {
    id: 'bif6kkrp0dp4vp059t2g',
    code: 'basketball',
    name: 'Basketball',
    active: true,
  },
];
